module.exports = {
	"pagination": {
		"DescribeJobFlows": {
			"result_key": "JobFlows"
		},
		"ListBootstrapActions": {
			"input_token": "Marker",
			"output_token": "Marker",
			"result_key": "BootstrapActions"
		},
		"ListClusters": {
			"input_token": "Marker",
			"output_token": "Marker",
			"result_key": "Clusters"
		},
		"ListInstanceFleets": {
			"input_token": "Marker",
			"output_token": "Marker",
			"result_key": "InstanceFleets"
		},
		"ListInstanceGroups": {
			"input_token": "Marker",
			"output_token": "Marker",
			"result_key": "InstanceGroups"
		},
		"ListInstances": {
			"input_token": "Marker",
			"output_token": "Marker",
			"result_key": "Instances"
		},
		"ListSteps": {
			"input_token": "Marker",
			"output_token": "Marker",
			"result_key": "Steps"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/elasticmapreduce-2009-03-31.paginators.json
// module id = 646
// module chunks = 0